import React from 'react';
import { Stars } from './Stars';
import { heroStats, topReviews } from '../data/content';
export function ReviewsBar() {
  return <section aria-label="Coach reviews and statistics" className="w-full bg-white px-5 py-12 sm:px-8" data-id="element-256" data-mp="2o9502z4ju2tp">
      <div className="mx-auto w-full max-w-6xl" data-id="element-257" data-mp="3235op01se9gc">
        <div className="grid grid-cols-2 gap-6 rounded-2xl border border-neutral-200 bg-neutral-50 px-6 py-7 sm:grid-cols-4" data-id="element-258" data-mp="2x1orpfmfb751">
          {heroStats.map(stat => <div key={stat.label} className="text-center" data-id="element-259" data-mp="25asdaakpsufn">
              <p className="text-2xl font-extrabold text-ember sm:text-3xl" data-id="element-260" data-mp="25cd71xz7g9cg">
                {stat.value}
              </p>
              <p className="mt-1 text-[11px] font-semibold uppercase tracking-[0.1em] text-neutral-600" data-id="element-261" data-mp="2j8gyjjip23l8">
                {stat.label}
              </p>
            </div>)}
        </div>

        <div className="mt-8 grid gap-5 md:grid-cols-3" data-id="element-262" data-mp="3urtgzfkydz3e">
          {topReviews.map(review => <figure key={review.name} className="flex h-full flex-col rounded-2xl border border-neutral-200 bg-white p-6" data-id="element-263" data-mp="3psq8fl5rlaqo">
              <Stars className="text-lg" data-id="element-264" data-mp="1h2sa9pwk3jo2" />
              <blockquote className="mt-3 text-[15px] font-medium italic leading-relaxed text-neutral-800" data-id="element-265" data-mp="1h5wntdvwvrre">
                {review.quote}
              </blockquote>
              <figcaption className="mt-auto pt-5" data-id="element-266" data-mp="1r1r8sfnlxyxc">
                <span className="block text-sm font-bold text-neutral-900" data-id="element-267" data-mp="ter8cztvv1hm">
                  {review.name}
                </span>
                <span className="block text-xs text-neutral-500" data-id="element-268" data-mp="yenasumxmkv2">{review.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}